import * as React from 'react';
import {
    Drawer,
    DrawerContent,
    DrawerItem,
    DrawerItemProps,
    DrawerSelectEvent,
} from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";

import PetsGrid from "./PetsGrid";
import AgenciesGrid from "./AgenciesGrid";
import LeafletsGrid from "./LeafletsGrid";
import UserGuideGrid from "./UserGuideGrid";
import PersonsGrid from "./PersonsGrid";
import ExamsGrid from "./Exam/ExamsGrid";
import ScheduleGrid from "./ScheduleGrid";
import VaccinesGrid from "./VaccinesGrid";
import ServicesGrid from "./ServicesGrid";
import FindingsGrid from "./FindingsGrid";
import EventsGrid from "./EventsGrid";
import OHTobaccosGrid from "./OHTobaccosGrid";
import Products from "./Product/Products";
import Inventory from "./Product/Inventory";
import EventSummaryGrid from "./Reports/EventSummaryGrid";
import ReportsGrid from "./Reports/ReportsGrid";

import { useAppSelector } from "../store/store";

const CustomItem = (props: DrawerItemProps) => {
    return (
        <DrawerItem {...props}>
            {props.icon ? <span className={"k-icon k-font-icon " + props.icon} role="presentation" /> : <img src={props.svg} alt="{props.text}" />}
            <span className={"k-item-text " + (props.groupheader === "false" ? "sds-drawerSub" : "")}>{props.text}</span>
        </DrawerItem>
    );
};

const DrawerRouterContainer = (props:any) => {
    const auth = useAppSelector((state) => state.auth);
    const role = (auth && (auth.user !== undefined) && auth.user.role) ? auth.user.role : "";
    const region = (auth && (auth.user !== undefined) && auth.user.region) ? auth.user.region : 0;

    const items:any = [];

    items.push({ text: "Exams", svg: "table.svg", group: "", groupheader: "true" });
    items.push({ separator: true });
    items.push({ text: "Appointments", icon: "k-i-calendar", group: "", groupheader: "true" });
    items.push({ separator: true });
    items.push({ text: "Leaflets", svg: "files.svg", group: "", groupheader: "true" });
    items.push({ separator: true });
    items.push({ text: "User Guide", icon: "k-i-help", group: "", groupheader: "true" });

    items.push({ separator: true });
    if ((role.indexOf("Admin") !== -1) || (role.indexOf("Inventory") !== -1)) {
        items.push({ text: "Admin", icon: "k-i-gears", group: "admin", groupheader: "true" });

        if(role.indexOf("Admin") !== -1) {
            items.push({ text: "Agencies", svg: "buildings.svg", group: "admin", groupheader: "false" });
            items.push({ text: "People", icon: "k-i-myspace", group: "admin", groupheader: "false" });
            items.push({ text: "Pets", svg: "paw-print.svg", group: "admin", groupheader: "false" });
        }
        items.push({ text: "Vaccines", svg: "syringe.svg", group: "admin", groupheader: "false" });

        if (role.indexOf("Inventory") !== -1) {
            items.push({ text: "Products", svg: "warehouse.svg", group: "admin", groupheader: "false" });
        }
        items.push({ text: "Inventory", svg: "storefront.svg", group: "admin", groupheader: "false" });

        if ((role.indexOf("Admin") !== -1) && (region === 2)) {
            items.push({ text: "Reports", svg: "cardholder.svg", group: "admin", groupheader: "false" });
        }

        items.push({ separator: true });
        items.push({ text: "Events", svg: "users-four.svg", group: "", groupheader: "true" });

   }

    if (((auth.user.region === 1) || (auth.user.region === 2) || (auth.user.region === 3) || (auth.user.region === 9) || (auth.user.region === 10) || (auth.user.region === 12))
            && ((role.indexOf("Admin") !== -1) || (role.indexOf("Inventory") !== -1) || (role.indexOf("OneHealth") !== -1))) {
        items.push({ separator: true });
        items.push({ text: "One Health", svg: "health.svg", group: "onehealth", groupheader: "true" });
        items.push({ text: "Tobacco", svg: "cigarette.svg", group: "onehealth", groupheader: "false" });
    }

    const [expanded, setExpanded] = React.useState(true);
    const [selectedText, setSelectedText] = React.useState(
        (role.indexOf("Inventory") !== -1) ? "Products" :
            (((role.indexOf("Admin") !== -1) || (role.indexOf("Case Worker") !== -1)) ? "Exams" :
                ((role.indexOf("OneHealth") !== -1) ? "Tobacco" : "Appointments"))
    );
    const [selectedGroup, setSelectedGroup] = React.useState((role.indexOf("OneHealth") !== -1) ? "onehealth" :
        ((role.indexOf("Inventory") !== -1) ? "admin" : ""));

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const onSelect = (e: DrawerSelectEvent) => {
        setSelectedText(e.itemTarget.props.text);
        if ((e.itemTarget.props.group === selectedGroup) && (e.itemTarget.props.groupheader === "true")) {
            setSelectedGroup("");
        } else {
            setSelectedGroup(e.itemTarget.props.group);
        }
    };

    return (
        <div>
            <Drawer
                expanded={expanded}
                position={"start"}
                mode={"push"}
                mini={true}
                items={items.map((item:any) => ({
                    ...item,
                    selected: item.text === selectedText,
                    style: ((item.groupheader === "true") || (item.group === selectedGroup)) ? { display: "flex" } : { display: "none" },
                }))}
                item={CustomItem}
                onSelect={onSelect}
            >
                <DrawerContent>
                    {(selectedText === "Exams") && (
                        <ExamsGrid />
                    )}
                    {(selectedText === "Appointments") && (
                        <ScheduleGrid />
                    )}
                    {(selectedText === "Leaflets") && (
                        <LeafletsGrid />
                    )}
                    {(selectedText === "User Guide") && (
                        <UserGuideGrid />
                    )}
                    {(selectedText === "Admin") && (
                        <AgenciesGrid />
                    )}
                    {(selectedText === "Agencies") && (
                        <AgenciesGrid />
                    )}
                    {(selectedText === "People") && (
                        <PersonsGrid />
                    )}
                    {(selectedText === "Pets") && (
                        <PetsGrid />
                    )}
                    {(selectedText === "Services") && (
                        <ServicesGrid />
                    )}
                    {(selectedText === "Findings") && (
                        <FindingsGrid />
                    )}
                    {(selectedText === "Vaccines") && (
                        <VaccinesGrid />
                    )}
                    {(selectedText === "Events") && (
                        <EventsGrid />
                    )}
                    {(selectedText === "One Health") && (
                        <OHTobaccosGrid />
                    )}
                   {(selectedText === "Tobacco") && (
                        <OHTobaccosGrid />
                    )}
                    {(selectedText === "Products") && (
                        <Products />
                    )}
                    {(selectedText === "Inventory") && (
                        <Inventory />
                    )}
                    {(selectedText === "Reports") && (
                        <ReportsGrid />
                    )}

                </DrawerContent>
            </Drawer>
            <div>
                
                <Button
                    icon={expanded === true ? "arrow-double-60-left" : "arrow-double-60-right"}
                    onClick={handleExpandClick}
                    style={{ position: "absolute", top:"41px", left:"0px" }}
                />                
            </div>
        </div>
    );
};

export default DrawerRouterContainer;